export default {
  init() {
    // JavaScript to be fired on the learn page



  },
  finalize() {
    // JavaScript to be fired on the learn page, after the init JS



  },
};



// WEBPACK FOOTER //
// ./scripts/routes/learn.js